import styled from 'styled-components';

const StyledContainer = styled.div`
	width: max-content;
	padding: 10px;
	border-radius: 10px;
	background: rgba(255, 255, 255, 0.9);
	opacity: 0;
	transition: opacity 0.25s ease;

	&.popup-enter {
		opacity: 0;
	}
	&.popup-enter-active,
	&.popup-enter-done,
	&.popup-exit {
		opacity: 1;
	}
	&.popup-exit-active {
		opacity: 0;
	}
`;

export { StyledContainer };
